import { useState } from 'react'
import { PRESET_CATEGORIES } from './presets'

export default function PresetPrompts({ onSelect }: { onSelect: (prompt: string) => void }) {
  const [selected, setSelected] = useState(PRESET_CATEGORIES[0])

  return (
    <section className="mx-auto w-full max-w-5xl px-6 pb-16">
      <div className="flex flex-wrap justify-center gap-2 pb-4">
        {PRESET_CATEGORIES.map((category) => {
          const isSelected = category === selected
          return (
            <button
              key={category.name}
              type="button"
              onClick={() => setSelected(category)}
              className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-[12.5px] font-medium transition ${
                isSelected
                  ? 'border-purple-200 bg-purple-50 text-purple-900'
                  : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:text-slate-900'
              }`}
            >
              <category.icon className="size-4 shrink-0" strokeWidth={isSelected ? 2 : 1.5} />
              {category.name}
            </button>
          )
        })}
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {selected.prompts.map(({ title, prompt }) => (
          <button
            key={title}
            type="button"
            onClick={() => onSelect(prompt)}
            className="group flex flex-col rounded-2xl border border-slate-200 bg-white p-5 text-left transition duration-200 hover:-translate-y-0.5 hover:border-purple-300 hover:shadow-[0_10px_28px_-14px_rgba(126,34,206,0.22)]"
          >
            <div className="flex items-start justify-between gap-3">
              <span className="font-heading text-base leading-snug font-semibold text-slate-900">{title}</span>
              <span className="shrink-0 text-slate-300 transition group-hover:translate-x-0.5 group-hover:text-purple-600">
                →
              </span>
            </div>
            <p className="mt-3 line-clamp-2 text-[12.5px] leading-relaxed text-slate-500">{prompt}</p>
          </button>
        ))}
      </div>
    </section>
  )
}
